export default __webpack_public_path__ + "static/media/screen2.98d4b5d1.png";